import React from 'react'
import { motion } from 'framer-motion'
import { Globe, User } from 'lucide-react'
import { cn } from '../../lib/utils'

const ViewModeToggle = ({ 
  viewMode, 
  onViewModeChange, 
  className,
  ...props 
}) => {
  const modes = [
    {
      id: 'all',
      label: 'All Projects',
      icon: Globe,
      description: 'Browse all public projects'
    },
    {
      id: 'my',
      label: 'My Projects',
      icon: User,
      description: 'View projects I created'
    }
  ]

  return (
    <div className={cn("relative inline-flex bg-white rounded-full p-1 border border-neutral-200 shadow-sm", className)} {...props}>
      {modes.map((mode) => (
        <motion.button
          key={mode.id}
          onClick={() => onViewModeChange(mode.id)}
          className={cn(
            "relative px-4 py-2 rounded-full transition-all duration-300 font-medium text-sm flex items-center gap-2 whitespace-nowrap",
            viewMode === mode.id
              ? "text-white"
              : "text-neutral-600 hover:text-neutral-900 hover:bg-neutral-50"
          )}
          whileHover={{ scale: viewMode === mode.id ? 1 : 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          {/* Active background */}
          {viewMode === mode.id && (
            <motion.div
              layoutId="activeViewMode"
              className="absolute inset-0 bg-primary-teal rounded-full shadow-md"
              transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
            />
          )}
          
          {/* Content */}
          <mode.icon className="w-4 h-4 relative z-10" />
          <span className="relative z-10">{mode.label}</span>
        </motion.button>
      ))}
    </div>
  )
}

export default ViewModeToggle